<div class="pointer-events-auto">
  <div>No Data Found.</div>

  <div>
    To create a Prepayment for a Vendor Contract, check “Prepaid Impact” for an Invoice in the
    <a class="aux-link cursor-pointer text-base" [routerLink]="[invoiceLibraryPage]">
      Invoice Library
    </a>
    .
  </div>
</div>
